import styled from "styled-components";

export const SectionContainer = styled.div`
  width: 100%;
  margin-top: 32px;

  @media (max-width: 768px) {
    margin-top: 24px;
  }

  .container-fluid {
    padding-left: 0;
    padding-right: 0;
  }
`;

export const CardSection = styled.div`
  background-color: ${(props) => props.bgColor || "#ffffff"};
  border-radius: 12px;
  padding: 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    transform: translateY(-2px);
  }

  @media (max-width: 768px) {
    padding: 20px;
  }

  @media (max-width: 480px) {
    padding: 16px;
  }
`;

export const CardContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 470px;
  width: 100%;
  gap: 8px;
  flex: 1;
`;

export const CardTitle = styled.h3`
  font-family: "Aeonik", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
    sans-serif;
  font-weight: 500;
  font-size: 24px;
  line-height: 1.33;
  color: #252b37;
  margin: 0;
  background: linear-gradient(45deg, #252b37 0%, #535862 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;

  @media (max-width: 992px) {
    font-size: 22px;
  }

  @media (max-width: 768px) {
    font-size: 20px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

export const CardDescription = styled.p`
  font-family: "Geist", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
    sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.5;
  color: #414651;
  margin: 0;
  flex: 1;

  @media (max-width: 768px) {
    font-size: 15px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

export const ActionButton = styled.button`
  margin-top: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 20px;
  background-color: #ffffff;
  border: 1px solid #d5d7da;
  border-radius: 8px;
  font-family: "Geist", sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.5;
  color: ${(props) => (props.variant === "primary" ? "#1841DD" : "#414651")};
  cursor: pointer;
  transition: all 0.2s ease;
  width: fit-content;
  align-self: flex-start;
  box-shadow: 0px 1px 2px 0px rgba(10, 13, 18, 0.05),
    inset 0px -2px 0px 0px rgba(10, 13, 18, 0.05),
    inset 0px 0px 0px 1px rgba(10, 13, 18, 0.18);

  &:hover {
    background-color: #f8f9fa;
    box-shadow: 0px 2px 4px 0px rgba(10, 13, 18, 0.1),
      inset 0px -2px 0px 0px rgba(10, 13, 18, 0.05),
      inset 0px 0px 0px 1px rgba(10, 13, 18, 0.18);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0px 1px 2px 0px rgba(10, 13, 18, 0.05),
      inset 0px 1px 0px 0px rgba(10, 13, 18, 0.1),
      inset 0px 0px 0px 1px rgba(10, 13, 18, 0.18);
  }

  @media (max-width: 768px) {
    padding: 10px 16px;
    font-size: 15px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    padding: 8px 14px;
    gap: 6px;
  }
`;

export const CardImageWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  max-width: 300px;
  margin: 0 auto;

  @media (min-width: 1200px) {
    justify-content: flex-end;
  }

  @media (max-width: 768px) {
    max-width: 280px;
    margin-top: 16px;
  }

  @media (max-width: 576px) {
    max-width: 100%;
    margin-top: 20px;
  }
`;

export const CardImage = styled.img`
  width: 100%;
  max-width: 300px;
  height: auto;
  aspect-ratio: 300/177;
  object-fit: contain;
  border-radius: 8px;

  @media (max-width: 1200px) {
    max-width: 280px;
  }

  @media (max-width: 992px) {
    max-width: 260px;
  }

  @media (max-width: 768px) {
    max-width: 280px;
  }

  @media (max-width: 576px) {
    max-width: 100%;
    aspect-ratio: 16/9;
  }

  @media (max-width: 480px) {
    aspect-ratio: 4/3;
  }
`;
